import { initPlugin as filtersInit } from './filters'
import { initPlugin as accessInit } from './access'
import { initPlugin as asyncDataInit } from './asyncData'
import { initPlugin as authorizedInit } from './authorized'
import { initPlugin as injectsInit } from './injects'
import './moment-precise-range-local'
import { initPlugin as noticeInit } from './notice'
import { initPlugin as portalVueInit } from './portal-vue'
import { initPlugin as veeValidateInit } from './vee-validate'
import { initPlugin as vuetifyInit } from './vuetify'


export const initPlugins = (options) => {
  injectsInit(options)

  filtersInit(options)
  // must be before accessInit
  authorizedInit(options)
  accessInit(options)
  asyncDataInit(options)
  noticeInit(options)
  portalVueInit(options)
  veeValidateInit(options)
  vuetifyInit(options)
}
